<template>
  <v-container fluid>
    <template v-if="$vuetify.breakpoint.smAndDown">
      <v-select
        v-model="selectedNavItem"
        dense
        outlined
        :items="navItems"
        item-text="title"
        item-value="path"
        return-object
        @change="goToSelectedPage"
      ></v-select>
      <router-view />
    </template>
    <v-row v-else>
      <v-col cols="12" md="2">
        <v-sheet outlined rounded>
          <v-list rounded nav>
            <v-list-item
              v-for="(navItem, index) in navItems"
              :key="`nav-item-${index}`"
            >
              <v-list-item-icon>
                <v-icon>{{ navItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <router-link
                    :to="navItem.path"
                    class="text-decoration-none"
                    active-class="font-weight-bold"
                    exact
                  >
                    {{ navItem.title }}
                  </router-link>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="10">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiAccount, mdiAccountCancel } from "@mdi/js";

export default {
  name: "LayoutInteressenten",
  data() {
    return {
      selectedNavItem: {},
      navItems: [
        {
          title: "Aktiv",
          path: "/backend/users/interessenten",
          icon: mdiAccount,
        },
        {
          title: "Neu / ungesehen",
          path: "/backend/users/interessenten/unread",
          icon: mdiAccount,
        },
        {
          title: "Inaktiv",
          path: "/backend/users/interessenten/inactive",
          icon: mdiAccountCancel,
        },
      ],
    };
  },
  mounted() {
    this.selectedNavItem = this.navItems.find(
      (navItem) => navItem.path === this.$route.path
    );
  },
  methods: {
    goToSelectedPage(selectedNavItem) {
      this.selectedNavItem = selectedNavItem;
      this.$router.push(selectedNavItem.path);
    },
  },
};
</script>

<style scoped></style>
